import React, { useState, useEffect } from "react";
import ApiConfig from "../common/config/ApiConfig";
import "./login.css";
import LoadingComponent from "./LoadingComponent"; // Replace with the correct path
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Dialog from "@mui/material/Dialog";
import { motion } from "framer-motion";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import moment from "moment";
import { Link } from "react-router-dom";
import Topnav from "./Topnav";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import Footer from "./Footer";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function ResultPreviewCard({
  flag,
  title,
  round,
  firstRows,
  threeTop,
  twobot,
  loading,
}) {
  const { t } = useTranslation();
  const dateLabel = firstRows[0]?.date
    ? moment(firstRows[0].date).format("ll")
    : null;

  return (
    <div className="w-full rounded-card overflow-hidden border-2 border-brand-gold-300/70 shadow-cardLight hover:shadow-card hover:-translate-y-0.5 transition-all duration-200 bg-white">
      <div className="flex items-center gap-2 bg-gradient-to-r from-brand-blue-700 via-brand-blue-600 to-brand-blue-700 px-3 py-2">
        <img
          src={flag}
          className="w-6 h-6 rounded-full object-cover ring-2 ring-brand-gold-300/70"
          alt=""
        />
        <span className="text-white font-bold text-xs xl:text-sm flex-1 font-heading">
          {title}
        </span>
        {dateLabel && (
          <span className="bg-white/20 text-white text-[9px] xl:text-[10px] font-semibold px-2 py-0.5 rounded-pill whitespace-nowrap">
            {dateLabel}
          </span>
        )}
        {round && (
          <span className="bg-brand-gold-300 text-brand-ink-onGold text-[9px] xl:text-[10px] font-bold px-2 py-0.5 rounded-pill whitespace-nowrap">
            {t("login.results.round")} {round}
          </span>
        )}
      </div>
      {loading ? (
        <LoadingComponent />
      ) : (
        <div className="grid grid-cols-2 divide-x divide-brand-blue-100 bg-gradient-to-br from-brand-blue-50 via-white to-brand-blue-50">
          <div className="flex flex-col items-center py-3 gap-1">
            <span className="text-brand-blue-600 text-[11px] xl:text-xs font-semibold">
              {t("login.results.threeTop")}
            </span>
            <span className="bg-white rounded-lg px-3 py-1 text-brand-blue-700 font-extrabold text-base xl:text-lg shadow-sm border border-brand-blue-100 font-heading">
              {threeTop[0]?.result_number || "XXX"}
            </span>
          </div>
          <div className="flex flex-col items-center py-3 gap-1">
            <span className="text-brand-blue-600 text-[11px] xl:text-xs font-semibold">
              {t("login.results.twoBottom")}
            </span>
            <span className="bg-white rounded-lg px-3 py-1 text-brand-blue-700 font-extrabold text-base xl:text-lg shadow-sm border border-brand-blue-100 font-heading">
              {twobot[0]?.result_number || "XX"}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default function SignInSide() {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const jsonData = {
      Username: data.get("username"),
      Password: data.get("password"),
    };

    fetch(`${process.env.REACT_APP_API_KEY}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.resCode === 200) {
          localStorage.setItem("token", data.data.token);
          localStorage.setItem("user", jsonData.Username);
          toast.success(t("login.toast.loginSuccess"), {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          window.location = "/dashboard";
        } else {
          toast.error(t("login.toast.loginError"), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(t("login.toast.networkError"), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////

  const [open, setOpen] = React.useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [bank, setBank] = useState("");
  const [banknumber, setBanknumber] = useState("");
  const [agent, setAgent] = useState("");
  const [step, setStep] = useState(1);
  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStep((prevStep) => prevStep - 1);
  };
  const handleClose = () => {
    setOpen(false);
    setUsername("");
    setPassword("");
    setFname("");
    setLname("");
    setMobileNumber("");
    setBank("");
    setBanknumber("");
    setAgent("");
  };

  const handleClickOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleSubmitregis = async (e) => {
    e.preventDefault();
    const json = {
      Username: username,
      Password: password,
      fname: fname,
      lname: lname,
      phone: mobileNumber,
      bank: bank,
      accout: banknumber,
      agent: agent,
    };
    fetch(`${process.env.REACT_APP_API_KEY}/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result === "aleady has this user") {
          toast.error(t("login.toast.usernameTaken"), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          setUsername("");
          setPassword("");
          setFname("");
          setLname("");
          setMobileNumber("");
          setBank("");
          setBanknumber("");
          setAgent("");
          toast.success(t("login.toast.registerSuccess"), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          window.location.reload(false);
        }
      });
  };
  const [loading, setLoading] = useState(true); // Loading state
  // const [Yeekeeloading, YeekeesetLoading] = useState(true); // Loading state
  const [result, setResult] = useState([]);
  // const [yeekeeSelect, setyeekeeSelect] = useState("yeekee_5");
  // const [yeekeeresult, setYeekeeresult] = useState([]);
  const [vtlHaiphongresult, SetvtlHaiphongresult] = useState([]);
  const [vtlphuquaresult, Setvtlphuquaresult] = useState([]);
  const [vtNgheAnresult, SetvtNgheAnresult] = useState([]);
  const [vtDalatresult, SetvtDalatresult] = useState([]);
  const [vtNhaTrangresult, SetvtNhaTrangresult] = useState([]);
  const [laoGov, SetlaoGov] = useState([]);
  const [agentlist] = useState([]);

  // const handleYeekeeSelect = (selection) => {
  //   setyeekeeSelect(selection);
  // };

  const ResGet = () => {
    const json = {
      lottotype: "th_gov",
    };

    ApiConfig.post("/getlastresult", json).then((result) => {
      if (result.resCode === 200) setResult(result.data);
      setLoading(false);
    });
  };

  const vtphuquaget = () => {
    const json = {
      lottotype: "hanoy_PhuQua",
      round: 1,
    };

    ApiConfig.post("/getlastresult_hanoi", json).then((result) => {
      if (result.resCode === 200) Setvtlphuquaresult(result.data);
    });
  };
  const vtHaiphongget = () => {
    const json = {
      lottotype: "hanoy_PhuQua",
      round: 2,
    };

    ApiConfig.post("/getlastresult_hanoi", json).then((result) => {
      if (result.resCode === 200) SetvtlHaiphongresult(result.data);
    });
  };
  const vtNgheAnget = () => {
    const json = {
      lottotype: "hanoy_PhuQua",
      round: 3,
    };

    ApiConfig.post("/getlastresult_hanoi", json).then((result) => {
      if (result.resCode === 200) SetvtNgheAnresult(result.data);
    });
  };
  const vtNhaTrangget = () => {
    const json = {
      lottotype: "hanoy_PhuQua",
      round: 4,
    };

    ApiConfig.post("/getlastresult_hanoi", json).then((result) => {
      if (result.resCode === 200) SetvtNhaTrangresult(result.data);
    });
  };
  const vtDalatget = () => {
    const json = {
      lottotype: "hanoy_PhuQua",
      round: 5,
    };

    ApiConfig.post("/getlastresult_hanoi", json).then((result) => {
      if (result.resCode === 200) SetvtDalatresult(result.data);
    });
  };
  const laosgovget = () => {
    const json = {
      lottotype: "laos_gov",
    };

    ApiConfig.post("/getlastresult", json).then((result) => {
      SetlaoGov(result.data);
    });
  };

  // useEffect(() => {
  //   const yeekeeget = () => {
  //     // YeekeesetLoading(true);
  //     // const json = {
  //     //   date: moment().format("YYYY-MM-DD"),
  //     //   lottotype: yeekeeSelect,
  //     // };

  //     ApiConfig.post("/getallresultbydate", json).then((result) => {
  //       console.log(result);
  //       // setYeekeeresult(result.data);
  //       // YeekeesetLoading(false);
  //     });
  //   };

  //   yeekeeget(); // Call the function initially

  //   // This effect will re-run whenever yeekeeSelect changes
  // }, [yeekeeSelect]);

  useEffect(() => {
    ResGet();
    vtNgheAnget();
    vtNhaTrangget();
    vtphuquaget();
    vtDalatget();
    vtHaiphongget();
    laosgovget();
  }, []);

  const totableLaosGov = {
    first: laoGov.filter((item) => item.type === "first"),
    three_top: laoGov.filter((item) => item.type === "three_top"),
    twobot: laoGov.filter((item) => item.type === "two_bot"),
  };

  const totableVtPhuqa = {
    first: vtlphuquaresult.filter((item) => item.type === "first"),
    three_top: vtlphuquaresult.filter((item) => item.type === "three_top"),
    twobot: vtlphuquaresult.filter((item) => item.type === "two_bot"),
  };

  const totableVtHaiphong = {
    first: vtlHaiphongresult.filter((item) => item.type === "first"),
    three_top: vtlHaiphongresult.filter((item) => item.type === "three_top"),
    twobot: vtlHaiphongresult.filter((item) => item.type === "two_bot"),
  };
  const totableVtNgheAn = {
    first: vtNgheAnresult.filter((item) => item.type === "first"),
    three_top: vtNgheAnresult.filter((item) => item.type === "three_top"),
    twobot: vtNgheAnresult.filter((item) => item.type === "two_bot"),
  };
  const totableVtNhaTrang = {
    first: vtNhaTrangresult.filter((item) => item.type === "first"),
    three_top: vtNhaTrangresult.filter((item) => item.type === "three_top"),
    twobot: vtNhaTrangresult.filter((item) => item.type === "two_bot"),
  };
  // console.log(totableVtNhaTrang)
  const totableVtDaLat = {
    first: vtDalatresult.filter((item) => item.type === "first"),
    three_top: vtDalatresult.filter((item) => item.type === "three_top"),
    twobot: vtDalatresult.filter((item) => item.type === "two_bot"),
  };

  const first = result.filter((item) => item.type === "first");
  const threefront = result.filter((item) => item.type === "three_front");
  const threebot = result.filter((item) => item.type === "three_bot");
  const twobot = result.filter((item) => item.type === "two_bot");

  return (
    <div className="flex flex-col min-h-screen">
      <Topnav />
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="content flex-1"
      >
        <div className="xl:flex xl:flex-col xl:mt-[20px] xl:w-[75%] w-[90%] xl:p-2 xl:h-auto xl:rounded mt-10">
          {/* login */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{
              opacity: 1,
              y: 0,
              scale: [1, 1.05, 1], // Scale animation effect
            }}
            transition={{
              duration: 1, // Duration of the animation
            }}
            className="xl:flex flex-col w-[100%] h-auto bg-gradient-to-br from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 p-2 border-2 border-brand-gold-300/70 rounded-card shadow-card"
          >
            <div className="xl:w-[100%] h-100 p-2 text-brand-gold-200">
              <span className="xl:text-[17px] font-bold font-heading">
                {t("login.tagline")}
              </span>
            </div>

            <div className="xl:flex xl:h-[60px] xl:flex-row xl:p-2 xl:place-content-between">
              <div className="xl:flex flex-row xl:space-x-4">
                <form
                  className="xl:flex flex flex-col w-auto xl:flex-row xl:space-x-2 xl:space-y-0 space-y-2 rounded"
                  onSubmit={handleSubmit}
                >
                  {/* /////////////////////////////////////////////////////////////////////////// */}

                  <div className="xl:flex flex w-auto flex-row bg-brand-blue-50 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-brand-gold-300 transition-shadow">
                    <div className="xl:w-[17%] w-[13%] h-auto bg-brand-blue-100 p-2">
                      <PersonIcon className="text-brand-blue-700" />
                    </div>
                    <div className="flex-grow">
                      <input
                        className="w-full xl:w-full p-2 h-full text-brand-blue-900 bg-transparent outline-none"
                        type="text"
                        placeholder={t("login.usernamePlaceholder")}
                        name="username"
                      />
                    </div>
                  </div>

                  {/* /////////////////////////////////////////////////////////////////////////// */}

                  <div className="xl:flex flex w-auto flex-row bg-brand-blue-50 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-brand-gold-300 transition-shadow">
                    <div className="xl:w-[17%] w-[13%] h-auto bg-brand-blue-100 p-2">
                      <LockIcon className="text-brand-blue-700" />
                    </div>
                    <div className="flex-grow">
                      <input
                        className="w-full xl:w-full p-2 h-full text-brand-blue-900 bg-transparent outline-none"
                        type="password"
                        placeholder={t("login.passwordPlaceholder")}
                        name="password"
                      />
                    </div>
                  </div>

                  {/* /////////////////////////////////////////////////////////////////////////// */}
                  <div className="flex justify-around space-x-2">
                    <motion.div
                      initial={{ opacity: 0, y: -20 }}
                      animate={{
                        opacity: 1,
                        y: 0,
                        scale: [1, 1.05, 1], // Scale animation effect
                      }}
                      transition={{
                        duration: 1, // Duration of the animation
                      }}
                      whileHover={{ y: -8, scale: 1.05 }}
                      style={{ height: "100% !important" }}
                    >
                      <button type="submit" className="golden-btn font-heading">
                        {t("login.signIn")}
                      </button>
                    </motion.div>
                    <motion.div
                      onClick={handleClickOpen}
                      initial={{ opacity: 0, y: -20 }}
                      animate={{
                        opacity: 1,
                        y: 0,
                        scale: [1, 1.05, 1], // Scale animation effect
                      }}
                      transition={{
                        duration: 1, // Duration of the animation
                      }}
                      whileHover={{ y: -8, scale: 1.05 }}
                      className="relative xl:flex items-center space-x-1 rounded-pill bg-brand-blue-600 px-4 py-3 hover:bg-brand-blue-500 text-white cursor-pointer"
                    >
                      <span
                        aria-hidden="true"
                        className="pointer-events-none absolute -inset-0.5 rounded-pill border-2 border-brand-gold-300 animate-cta-pulse-ring"
                      />
                      <HowToRegIcon className="xl:text-[14px] font-bold text-brand-gold-200 " />
                      <span className="xl:text-[14px] text-white font-heading">
                        {t("login.registerButton")}
                      </span>
                    </motion.div>
                  </div>

                  <Link
                    to="/contact"
                    className="xl:flex flex-row items-center p-2 space-x-1 w-fit"
                  >
                    <SupportAgentIcon className="xl:text-[14px] font-bold text-brand-gold-200 " />
                    <span className="xl:text-[14px] text-brand-gold-200 hover:text-brand-gold-100 cursor-pointer">
                      {t("login.contactUs")}
                    </span>
                  </Link>
                </form>
              </div>
            </div>
          </motion.div>
          {/* login */}

          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{
              opacity: 1,
              y: 0,
              scale: [1, 1.05, 1], // Scale animation effect
            }}
            transition={{
              duration: 1, // Duration of the animation
            }}
            className="xl:flex flex-col w-[100%] h-auto mt-3 bg-brand-blue-50 rounded-card overflow-hidden border-2 border-brand-gold-300/70 shadow-card"
          >
            <div className="xl:flex flex-row items-center bg-gradient-to-r from-brand-blue-800 via-brand-blue-700 to-brand-blue-800 w-[100%] h-[40px] p-2 space-x-2 shadow-card">
              <span className="text-[10px] xl:text-[13px] font-semibold text-white/90 hover:text-white hover:bg-white/10 px-2 py-1 rounded-full transition-colors cursor-pointer">
                {t("login.nav.payoutRates")}
              </span>
              <Link
                to="/contact"
                className="text-[10px] xl:text-[13px] font-semibold text-white/90 hover:text-white hover:bg-white/10 px-2 py-1 rounded-full transition-colors cursor-pointer"
              >
                {t("login.contactUs")}
              </Link>
              <span className="text-[10px] xl:text-[13px] font-semibold text-white/90 hover:text-white hover:bg-white/10 px-2 py-1 rounded-full transition-colors cursor-pointer">
                {t("login.nav.aboutUs")}
              </span>
              <span className="text-[10px] xl:text-[13px] font-semibold text-white/90 hover:text-white hover:bg-white/10 px-2 py-1 rounded-full transition-colors cursor-pointer">
                {t("login.nav.reviews")}
              </span>
            </div>

            <div className="xl:bg-brand-blue-50 flex flex-col p-1 w-[100%] h-auto space-y-3">
              <motion.div className="xl:flex flex-col w-[100%] rounded-card overflow-hidden shadow-cardLight">
                <div className="flex flex-col justify-center items-center bg-gradient-to-r from-brand-blue-700 via-brand-blue-600 to-brand-blue-700 p-3 space-y-2">
                  <div className="flex flex-row items-center space-x-2">
                    <img
                      className="w-[28px] rounded-full ring-2 ring-brand-gold-300/70"
                      src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg"
                      alt=""
                    />
                    <span className="text-white font-bold text-sm xl:text-base font-heading">
                      {t("login.results.thGov")}
                    </span>
                  </div>
                  <div className="text-center rounded-full bg-white/15 px-3 py-1 flex justify-center items-center">
                    {first.map((row, index) => (
                      <span
                        key={index}
                        className="text-white font-semibold xl:text-[12px] text-[9px]"
                      >
                        {moment(row.date).format("ll")}
                      </span>
                    ))}
                  </div>
                  <div className="flex w-full justify-center items-center space-x-1.5 flex-row">
                    {[0, 1, 2, 3, 4, 5].map((i) => (
                      <div
                        key={i}
                        className="w-[10%] xl:w-[3%] py-1.5 rounded-lg place-content-center bg-gradient-to-b from-brand-gold-300 to-brand-gold-600 shadow-gold flex justify-center"
                      >
                        {first.map((row, index) => (
                          <span
                            key={index}
                            className="text-brand-ink-onGold font-extrabold text-[15px] xl:text-[25px] font-heading"
                          >
                            {row.result_number.charAt(i)}
                          </span>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  {loading ? (
                    <LoadingComponent />
                  ) : (
                    <div className="p-3 bg-gradient-to-br from-brand-blue-50 via-white to-brand-blue-50">
                      <div className="w-full flex justify-center items-center flex-row xl:flex-row">
                        <div className="w-full xl:w-[25%] text-center">
                          <span className="text-brand-blue-600 text-[13px] xl:text-[15px] font-semibold">
                            {t("login.results.threeFront")}
                          </span>
                        </div>
                        <div className="w-full xl:w-[25%] text-center">
                          <span className="text-brand-blue-600 text-[13px] xl:text-[15px] font-semibold">
                            {t("login.results.threeBack")}
                          </span>
                        </div>
                        <div className="w-full xl:w-[25%] text-center">
                          <span className="text-brand-blue-600 text-[13px] xl:text-[15px] font-semibold">
                            {t("login.results.twoBottom")}
                          </span>
                        </div>
                      </div>
                      <div className="w-full flex justify-center items-center flex-row xl:flex-row p-1 gap-2">
                        <div className="w-[50%] xl:w-[25%] flex justify-center items-center text-center">
                          <div className="w-[70%] xl:w-[50%] bg-white rounded-lg py-1 place-content-center border border-brand-blue-100 shadow-sm flex justify-center">
                            {threefront.map((row, index) => (
                              <span
                                className="text-[10px] xl:text-[20px] text-brand-blue-700 font-bold font-heading"
                                style={{
                                  paddingLeft: "1rem",
                                  paddingRight: "1rem",
                                }}
                                key={index}
                              >
                                {row.result_number}
                              </span>
                            ))}
                          </div>
                        </div>
                        <div className="w-full xl:w-[25%] text-center flex justify-center items-center">
                          <div className="w-[70%] xl:w-[50%] bg-white rounded-lg py-1 place-content-center border border-brand-blue-100 shadow-sm flex justify-center">
                            {threebot.map((row, index) => (
                              <span
                                className="text-[10px] xl:text-[20px] text-brand-blue-700 font-bold font-heading"
                                style={{
                                  paddingLeft: "1rem",
                                  paddingRight: "1rem",
                                }}
                                key={index}
                              >
                                {row.result_number}
                              </span>
                            ))}
                          </div>
                        </div>

                        <div className="w-full xl:w-[25%] text-center flex justify-center items-center">
                          <div className="w-[70%] xl:w-[50%] bg-white rounded-lg py-1 place-content-center border border-brand-blue-100 shadow-sm flex justify-center">
                            {twobot.map((row, index) => (
                              <span
                                className="text-[10px] xl:text-[20px] text-brand-blue-700 font-bold font-heading"
                                style={{
                                  paddingLeft: "1rem",
                                  paddingRight: "1rem",
                                }}
                                key={index}
                              >
                                {row.result_number}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="grid grid-cols-1 sm:grid-cols-3 gap-2"
              >
                <ResultPreviewCard
                  flag="https://upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Laos.svg"
                  title={t("login.results.laos")}
                  firstRows={totableLaosGov.first}
                  threeTop={totableLaosGov.three_top}
                  twobot={totableLaosGov.twobot}
                  loading={loading}
                />
                <ResultPreviewCard
                  flag="https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg"
                  title={t("login.results.hanoi")}
                  round={totableVtPhuqa.first[0]?.round}
                  firstRows={totableVtPhuqa.first}
                  threeTop={totableVtPhuqa.three_top}
                  twobot={totableVtPhuqa.twobot}
                  loading={loading}
                />
                <ResultPreviewCard
                  flag="https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg"
                  title={t("login.results.hanoi")}
                  round={totableVtHaiphong.first[0]?.round}
                  firstRows={totableVtHaiphong.first}
                  threeTop={totableVtHaiphong.three_top}
                  twobot={totableVtHaiphong.twobot}
                  loading={loading}
                />
                <ResultPreviewCard
                  flag="https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg"
                  title={t("login.results.hanoi")}
                  round={totableVtNgheAn.first[0]?.round}
                  firstRows={totableVtNgheAn.first}
                  threeTop={totableVtNgheAn.three_top}
                  twobot={totableVtNgheAn.twobot}
                  loading={loading}
                />
                <ResultPreviewCard
                  flag="https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg"
                  title={t("login.results.hanoi")}
                  round={totableVtNhaTrang.first[0]?.round}
                  firstRows={totableVtNhaTrang.first}
                  threeTop={totableVtNhaTrang.three_top}
                  twobot={totableVtNhaTrang.twobot}
                  loading={loading}
                />
                <ResultPreviewCard
                  flag="https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg"
                  title={t("login.results.hanoi")}
                  round={totableVtDaLat.first[0]?.round}
                  firstRows={totableVtDaLat.first}
                  threeTop={totableVtDaLat.three_top}
                  twobot={totableVtDaLat.twobot}
                  loading={loading}
                />
              </motion.div>
              {/* <div className="xl:flex flex-col w-[100%] bg-sky-50 rounded-t border-black drop-shadow-xl ">
                <div className="flex flex-col bg-zinc-700 rounded-t p-2 space-x-2 justify-center items-center">
                  <EmojiEventsIcon className="ml-3" />
                  <div className="xl:w-[10%] w-[20%] h-[20px] text-center mt-1 rounded border-black border-1 bg-white flex justify-center items-center">
                    <span className="text-black font-bold xl:text-[9px] text-[7px]">
                      {moment().format("ll")}
                    </span>
                  </div>
                </div>
                <div className="flex flex-row bg-zinc-700 p-2 justify-center items-center">
                  <div
                    onClick={() => handleYeekeeSelect("yeekee_5")}
                    className="bg-red-700 w-full p-2 text-center hover:bg-red-900"
                  >
                    <span className="text-white font-bold text-[10px] xl:text-[20px]">
                      กดดูผลยี่กี
                    </span>
                  </div>
                  <div
                    onClick={() => handleYeekeeSelect("yeekee_10")}
                    className="bg-purple-700 w-full p-2 text-center hover:bg-purple-900"
                  >
                    <span className="text-white font-bold text-[10px] xl:text-[20px]">
                      กดดูผลยี่กี VIP
                    </span>
                  </div>
                  <div
                    onClick={() => handleYeekeeSelect("yeekee_15")}
                    className="bg-green-700 w-full p-2 text-center hover:bg-green-900"
                  >
                    <span className="text-white font-bold text-[10px] xl:text-[20px]">
                      กดดูผลยี่กี VVIP
                    </span>
                  </div>
                </div>

                {Yeekeeloading ? (
                  <LoadingComponent />
                ) : (
                  <div className="border-black border-[1px]">
                    {yeekeeSelect === "yeekee_5" && (
                      <div className="w-full p-2 overflow-auto">
                        <div className="grid grid-cols-1 xl:grid-cols-1 lg:grid-cols-2 gap-1">
                          {yeekeeresult.map((row, index) => (
                            <div
                              key={index}
                              className="w-full bg-gradient-to-r from-indigo-400 via-purple-400 to-indigo-400 flex flex-col border-[1px] rounded-lg"
                            >
                              <div className="w-[full] pt-2 rounded-t-lg justify-center items-center text-center bg-purple-700">
                                <span className="text-white text-[10px] xl:text-[15px]">
                                  จับยี่กีปกติ | รอบที่ {row.round}
                                </span>
                              </div>
                              <div className="w-full flex flex-row">
                                <div className="w-full border-b-white border-b-[1px] text-center">
                                  <span className="text-white text-[10px] xl:text-[15px]">
                                    3 ตัวบน
                                  </span>
                                </div>
                                <div className="w-full border-white border-b-[1px] text-center">
                                  <span className="text-white text-[10px] xl:text-[15px]">
                                    2 ตัวล่าง
                                  </span>
                                </div>
                              </div>
                              <div className="w-full p-1 flex flex-row">
                                <div className="w-full text-center">
                                  <div className="flex flex-row space-x-2 place-content-center">
                                    <div className="xl:w-[50%] bg-slate-200 px-2 rounded place-content-center border border-gray-200 flex justify-center">
                                      <span className="text-black font-bold text-[10px] xl:text-[16px]">
                                        {row.result_number.slice(0, 3)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="w-full flex justify-center items-center">
                                  <div className="xl:w-[50%] bg-slate-200 px-2 rounded place-content-center border border-gray-200 flex justify-center">
                                    <span className="text-black font-bold text-[10px] xl:text-[16px]">
                                      {row.result_number.slice(3, 5)}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {yeekeeSelect === "yeekee_10" && (
                      <div className="w-full p-2 overflow-auto">
                        <div className="grid grid-cols-1 xl:grid-cols-1 lg:grid-cols-2 gap-1">
                          {yeekeeresult.map((row, index) => (
                            <div
                              key={index}
                              className="w-full bg-gradient-to-r from-indigo-400 via-purple-400 to-indigo-400 flex flex-col border-[1px] rounded-lg"
                            >
                              <div className="w-[full] pt-2 rounded-t-lg justify-center items-center text-center bg-purple-700">
                                <span className="text-white text-[10px] xl:text-[15px]">
                                  จับยี่กี 10 นาที | รอบที่ {row.round}
                                </span>
                              </div>
                              <div className="w-full flex flex-row">
                                <div className="w-full border-b-white border-b-[1px] text-center">
                                  <span className="text-white text-[10px] xl:text-[15px]">
                                    3 ตัวบน
                                  </span>
                                </div>
                                <div className="w-full border-white border-b-[1px] text-center">
                                  <span className="text-white text-[10px] xl:text-[15px]">
                                    2 ตัวล่าง
                                  </span>
                                </div>
                              </div>
                              <div className="w-full p-1 flex flex-row">
                                <div className="w-full text-center">
                                  <div className="flex flex-row space-x-2 place-content-center">
                                    <div className="xl:w-[50%] bg-slate-200 px-2 rounded place-content-center border border-gray-200 flex justify-center">
                                      <span className="text-black font-bold text-[10px] xl:text-[16px]">
                                        {row.result_number.slice(0, 3)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="w-full flex justify-center items-center">
                                  <div className="xl:w-[50%] bg-slate-200 px-2 rounded place-content-center border border-gray-200 flex justify-center">
                                    <span className="text-black font-bold text-[10px] xl:text-[16px]">
                                      {row.result_number.slice(3, 5)}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {yeekeeSelect === "yeekee_15" && (
                      <div className="w-full p-2 overflow-auto">
                        <div className="grid grid-cols-1 xl:grid-cols-1 lg:grid-cols-2 gap-1">
                          {yeekeeresult.map((row, index) => (
                            <div
                              key={index}
                              className="w-full bg-gradient-to-r from-indigo-400 via-purple-400 to-indigo-400 flex flex-col border-[1px] rounded-lg"
                            >
                              <div className="w-[full] pt-2 rounded-t-lg justify-center items-center text-center bg-purple-700">
                                <span className="text-white text-[10px] xl:text-[15px]">
                                  จับยี่กี 15 นาที | รอบที่ {row.round}
                                </span>
                              </div>
                              <div className="w-full flex flex-row">
                                <div className="w-full border-b-white border-b-[1px] text-center">
                                  <span className="text-white text-[10px] xl:text-[15px]">
                                    3 ตัวบน
                                  </span>
                                </div>
                                <div className="w-full border-white border-b-[1px] text-center">
                                  <span className="text-white text-[10px] xl:text-[15px]">
                                    2 ตัวล่าง
                                  </span>
                                </div>
                              </div>
                              <div className="w-full p-1 flex flex-row">
                                <div className="w-full text-center">
                                  <div className="flex flex-row space-x-2 place-content-center">
                                    <div className="xl:w-[50%] bg-slate-200 px-2 rounded place-content-center border border-gray-200 flex justify-center">
                                      <span className="text-black font-bold text-[10px] xl:text-[16px]">
                                        {row.result_number.slice(0, 3)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="w-full flex justify-center items-center">
                                  <div className="xl:w-[50%] bg-slate-200 px-2 rounded place-content-center border border-gray-200 flex justify-center">
                                    <span className="text-black font-bold text-[10px] xl:text-[16px]">
                                      {row.result_number.slice(3, 5)}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div> */}
            </div>
          </motion.div>
        </div>
      </motion.div>
      {/* <Footer/> */}

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
        >
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              className="bg-gradient-to-r from-brand-blue-800 to-brand-blue-600 text-[20px] text-white font-heading"
              id="alert-dialog-title"
            >
              {t("login.registerDialog.title")}
            </DialogTitle>
            <div className="App">
              <form onSubmit={handleSubmitregis}>
                {step === 1 && (
                  <>
                    <div className="w-full p-1 flex flex-col justify-center items-center">
                      <img
                        className="w-[15%] mt-1"
                        src="/images/registered.png"
                        alt=""
                      />
                      <div className="w-full p-3 space-x-1 flex flex-row justify-center items-center">
                        <div className="w-[10px] h-[10px] rounded-full bg-brand-blue-600 border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                      </div>
                      <div className="register p-2 grid grid-cols-2 gap-4">
                        <input
                          type="text"
                          value={username}
                          placeholder={t("login.usernamePlaceholder")}
                          onChange={(e) => setUsername(e.target.value)}
                          className="col-span-2 px-4 py-2 border-b-[2px] border-slate-500 focus:outline-none focus:border-brand-blue-600 hover:bg-brand-blue-50"
                        />
                        <input
                          type="password"
                          value={password}
                          placeholder={t("login.passwordPlaceholder")}
                          onChange={(e) => setPassword(e.target.value)}
                          className="col-span-2 px-4 py-2 border-b-[2px] border-slate-500 focus:outline-none focus:border-brand-blue-600 hover:bg-brand-blue-50"
                        />
                      </div>
                    </div>
                    <DialogActions>
                      <button
                        onClick={handleNext}
                        className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
                      >
                        <ArrowForwardIosIcon />
                      </button>
                    </DialogActions>
                  </>
                )}
                {step === 2 && (
                  <>
                    <div className="w-full p-1 flex flex-col justify-center items-center">
                      <img
                        className="w-[15%] mt-1"
                        src="/images/registered.png"
                        alt=""
                      />
                      <div className="w-full p-3 space-x-1 flex flex-row justify-center items-center">
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-brand-blue-500 border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                      </div>
                      <div className="register p-2 grid grid-cols-2 gap-4">
                        <input
                          type="text"
                          value={fname}
                          placeholder={t(
                            "login.registerDialog.firstNamePlaceholder",
                          )}
                          onChange={(e) => setFname(e.target.value)}
                          className="col-span-2 px-4 py-2 border-b-[2px] border-slate-500 focus:outline-none focus:border-brand-blue-600 hover:bg-brand-blue-50"
                        />
                        <input
                          type="text"
                          value={lname}
                          placeholder={t(
                            "login.registerDialog.lastNamePlaceholder",
                          )}
                          onChange={(e) => setLname(e.target.value)}
                          className="col-span-2 px-4 py-2 border-b-[2px] border-slate-500 focus:outline-none focus:border-brand-blue-600 hover:bg-brand-blue-50"
                        />
                      </div>
                    </div>
                    <DialogActions>
                      <button
                        onClick={handlePrevious}
                        className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
                      >
                        <ArrowBackIosIcon />
                      </button>
                      <button
                        onClick={handleNext}
                        className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
                      >
                        <ArrowForwardIosIcon />
                      </button>
                    </DialogActions>
                  </>
                )}
                {step === 3 && (
                  <>
                    <div className="w-full p-1 flex flex-col justify-center items-center">
                      <img
                        className="w-[15%] mt-1"
                        src="/images/phone-call.png"
                        alt=""
                      />
                      <div className="w-full p-3 space-x-1 flex flex-row justify-center items-center">
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-brand-blue-500 border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                      </div>
                      <div className="register p-2 grid grid-cols-2 gap-4">
                        <input
                          type="number"
                          value={mobileNumber}
                          placeholder={t(
                            "login.registerDialog.phonePlaceholder",
                          )}
                          onChange={(e) => setMobileNumber(e.target.value)}
                          className="col-span-2 px-4 py-2 border-b-[2px] border-slate-500 focus:outline-none focus:border-brand-blue-600 hover:bg-brand-blue-50"
                        />
                      </div>
                    </div>
                    <DialogActions>
                      <button
                        onClick={handlePrevious}
                        className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
                      >
                        <ArrowBackIosIcon />
                      </button>
                      <button
                        onClick={handleNext}
                        className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
                      >
                        <ArrowForwardIosIcon />
                      </button>
                    </DialogActions>
                  </>
                )}
                {step === 4 && (
                  <>
                    <div className="w-full p-1 flex flex-col justify-center items-center">
                      <img
                        className="w-[15%] mt-1"
                        src="/images/money.png"
                        alt=""
                      />
                      <div className="w-full p-3 space-x-1 flex flex-row justify-center items-center">
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-white border-[1px] border-slate-500"></div>
                        <div className="w-[10px] h-[10px] rounded-full bg-brand-blue-500 border-[1px] border-slate-500"></div>
                      </div>
                      <div className="register p-2 grid grid-cols-2 gap-4">
                        <span>{t("login.registerDialog.selectBank")}</span>
                        <select
                          id="employee"
                          name="employee"
                          onChange={(e) => setBank(e.target.value)}
                          className="bg-gray-100 rounded-lg px-4 py-2"
                        >
                          <option></option>
                          <option value="KBANK">
                            {t("login.registerDialog.banks.kbank")}
                          </option>
                          <option value="SCB">
                            {t("login.registerDialog.banks.scb")}
                          </option>
                          <option value="KTB">
                            {t("login.registerDialog.banks.ktb")}
                          </option>
                          <option value="BBL">
                            {t("login.registerDialog.banks.bbl")}
                          </option>
                          <option value="GSB">
                            {t("login.registerDialog.banks.gsb")}
                          </option>
                        </select>

                        <input
                          type="number"
                          value={banknumber}
                          placeholder={t(
                            "login.registerDialog.bankAccountPlaceholder",
                          )}
                          onChange={(e) => setBanknumber(e.target.value)}
                          className="col-span-2 px-4 py-2 border-b-[2px] border-slate-500 focus:outline-none focus:border-brand-blue-600 hover:bg-brand-blue-50"
                        />

                        <span>{t("login.registerDialog.agent")}</span>
                        <select
                          id="employee"
                          name="employee"
                          onChange={(e) => setAgent(e.target.value)}
                          className="bg-gray-100 rounded-lg px-4 py-2"
                        >
                          <option></option>
                          {agentlist.map((row) => (
                            <option key={row.Username} value={row.Username}>
                              {row.Username}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <DialogActions>
                      <button
                        onClick={handlePrevious}
                        className="bg-brand-blue-600 mr-1 hover:bg-brand-blue-700 text-white font-bold py-2 px-4 mr-1 rounded"
                      >
                        <ArrowBackIosIcon />
                      </button>
                      <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{
                          opacity: 1,
                          y: 0,
                          scale: [1, 1.05, 1], // Scale animation effect
                        }}
                        transition={{
                          duration: 1, // Duration of the animation
                        }}
                        whileHover={{ y: -4, scale: 1.05 }}
                        style={{ height: "100% !important" }}
                      >
                        <button
                          type="submit"
                          className="bg-green-600 mr-1 hover:bg-green-700 text-white font-bold py-2 px-4 mr-1 rounded"
                        >
                          <SaveAltIcon /> {t("login.registerButton")}
                        </button>
                      </motion.div>
                    </DialogActions>
                  </>
                )}
              </form>
            </div>
          </Dialog>
        </motion.div>
      )}
      <Footer />
    </div>
  );
}
